import {
  CdkDrag,
  CdkDragDrop,
  CdkDragHandle,
  CdkDragPlaceholder,
  CdkDropList,
  moveItemInArray
} from "@angular/cdk/drag-drop";
import { AsyncPipe, CommonModule } from "@angular/common";
import { Component, Input, inject } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialog } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Router, RouterLink } from "@angular/router";
import { Store, select } from "@ngrx/store";
import { Editor, NgxEditorModule, Toolbar } from "ngx-editor";
import { Observable, first, firstValueFrom, map } from "rxjs";
import { AcuerdoMrbService } from "../../../acuerdo-mrb/acuerdo-mrb.service";
import { AppState } from "../../../app.state";
import { ConfirmDialogComponent } from "../../../confirm-dialog/confirm-dialog.component";
import { iAcuerdo, iCatalogos } from "../../../entrada/entrada.interface";
import { IAcuerdo, IAcuerdoSeleccionado } from "../../../interfaces/acuerdos";
import { IUsuario } from "../../../interfaces/catalogos.";
import { IEntrada, INuevaEntrada } from "../../../interfaces/entradas";
import { IArchivoAdjunto } from "../../../interfaces/storage";
import {
  IDetalleTema,
  IIndicacionAB,
  StateIndicacionAB,
} from "../../../interfaces/temas";
import { LoadingService } from "../../../loading/loading.service";
import { OrderAscDescPipe } from "../../../pipes/asc-desc-order/order-asc-des.pipe";
import { AcuerdosService } from "../../../services/acuerdos/acuerdos.service";
import { EntradasService } from "../../../services/entradas/entradas.service";
import { EntregablesService } from "../../../services/entregables/entregables.service";
import { IndicacionesService } from "../../../services/indicaciones/indicaciones.service";
import { StorageService } from "../../../services/storage/files.service";
import { selectAcuerdo } from "../../../states/acuerdo/selector";
import { selectAllAcuerdos } from "../../../states/acuerdos-mrb/selector";
import { selectCatalogos } from "../../../states/catalogos/selector";
import { selectEntradas } from "../../../states/entradas/selector";
import {
  selectAcuerdoSelected,
  selectAcuerdoTemas,
} from "../../../states/temas/selectors";
import { selectUsuario } from "../../../states/usuario/selector";
import { toolbarEditor } from "../../../utils";
import { AplazarTemaComponent } from "../dialogs/aplazar-tema/aplazar-tema.component";
import { QuitarTemaAMrbComponent } from "../dialogs/quitar-tema/quitar-tema.component";
import { TerminarTemaAMrbComponent } from "../dialogs/terminar-tema/terminar-tema.component";
import { NuevoTemaComponent } from "../nuevo-tema/nuevo-tema.component";
import { AcuerdosUtilsService } from "../utils";
import { accionesAcuerdos, stripHtml } from "./dtoDetalleTema";
import { cargarEntradas } from "../../../states/entradas/actions";

@Component({
  selector: "app-detalle-tema",
  standalone: true,
  imports: [
    MatIconModule,
    NgxEditorModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatButtonModule,
    FormsModule,
    MatCardModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    AsyncPipe,
    CdkDropList,
    CdkDrag,
    CdkDragPlaceholder,
    CdkDragHandle,
    MatTooltipModule,
    //NuevoTemaComponent,
    RouterLink,
    MatBadgeModule,
    OrderAscDescPipe,
  ],
  templateUrl: "./detalle-tema.component.html",
  styleUrl: "./detalle-tema.component.css",
})
export class DetalleTemaComponent {
  @Input() temasAcuerdo!: FormGroup;
  private readonly stateAcuerdo: any = this.store.pipe(select(selectAcuerdo));
  private readonly stateTipoAcuerdo: any = this.store.pipe(
    select(selectAllAcuerdos)
  );

  private stateEntradas: any = this.store.pipe(select(selectEntradas));
  private stateUser: any = this.store.pipe(select(selectUsuario));

  private acuerdoMrbService = inject(AcuerdoMrbService);
  private acuerdoService = inject(AcuerdosService);
  private indicacionesService = inject(IndicacionesService);
  private entregablesService = inject(EntregablesService);
  private loadingService = inject(LoadingService);
  private storageService = inject(StorageService);
  private entradasService = inject(EntradasService);
  private readonly stateCatalogos: any = this.store.pipe(
    select(selectCatalogos)
  );

  public editor!: Editor;
  public catCategoria: any[] = [];
  public catCategorizacion: any[] = [];
  public catTipoTema: any[] = [];
  public catUsuarios: any[] = [];
  public catEntrada: any[] = [];

  public indicacionActual: IIndicacionAB = StateIndicacionAB;
  public editandoIndicacion: boolean = false;
  public oCatalogos: iCatalogos;
  public oAcuerdo: iAcuerdo;
  public user!: IUsuario;
  public listaEntradas: IEntrada[] = [];
  public temasForm: FormGroup;
  public temas$!: Observable<IDetalleTema[]>;
  public editorInstances: { [key: string]: Editor } = {};
  acuerdoSeleccionado$!: Observable<IAcuerdoSeleccionado>;
  acuerdoActual!: IAcuerdo;
  public idTemaSeleccionado: string = "";
  public disabled!: boolean;

  public toolbar: Toolbar = toolbarEditor;

  public acciones: any[] = [];
  public mostrarEntradas = false;

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private router: Router,
    private store: Store<AppState>,
    private acuerdosService: AcuerdosService,
    private acuerdoUtils: AcuerdosUtilsService
  ) {
    this.temasForm = this.fb.group({
      temas: this.fb.array([]),
    });
    this.temas$ = this.store.pipe(select(selectAcuerdoTemas));
    this.oCatalogos = structuredClone(this.stateCatalogos.state().catalogos);
    this.oAcuerdo = structuredClone(this.stateAcuerdo.state().acuerdo);

    this.user = this.stateUser.state().usuario;
    this.catUsuarios = this.oCatalogos.catUsuarios;
  }

  async ngOnInit() {
    console.log("temasAcuerdo ngOnInit ==========", this.temasAcuerdo);

    this.disabled =
      structuredClone(this.stateTipoAcuerdo.state().acuerdosMRB.tipoAcuerdo) ===
      3;

    const tipoAcuerdo: number =
      this.stateTipoAcuerdo.state().acuerdosMRB.tipoAcuerdo;
    this.acciones = accionesAcuerdos(tipoAcuerdo);

    this.listaEntradas = await this.stateEntradas.state().entradas.entradas;
    this.listaEntradas = Object.values(this.listaEntradas);
    this.editor = new Editor();
    this.catCategoria = await firstValueFrom(
      this.acuerdoMrbService.getCategoria()
    );
    const catCategorizacion = await firstValueFrom(
      this.acuerdoMrbService.getCatalogo(
        this.acuerdoMrbService.cats.CATEGORIZACION
      )
    );
    this.catCategorizacion =
      this.acuerdoUtils.getCategorizacioCombo(catCategorizacion);
    console.log("catCategorizacion", this.catCategorizacion);

    this.catTipoTema = await firstValueFrom(
      this.acuerdoMrbService.getCatalogo(this.acuerdoMrbService.cats.TIPO_TEMA)
    );
    this.acuerdoSeleccionado$ = this.store.select(selectAcuerdoSelected);
    this.acuerdoSeleccionado$.subscribe((data) => {
      this.acuerdoActual = data.acuerdo;
    });

    const temaActalizado = this.temasAcuerdoArray.value.find(
      (tema: any) => tema.expanded || tema.verTema
    );

    if (temaActalizado) {
      this.editorInstances[temaActalizado.editorInstanceId] = new Editor();
    }
    console.log("temaActalizado", temaActalizado);
  }
  ngOnDestroy(): void {
    Object.values(this.editorInstances).forEach((editor) => editor.destroy());
  }

  getCategoriaDescripcion(id: string): string {
    const categoria = this.catCategoria.find((item) => item.id === id);
    return categoria ? categoria.descripcion : "";
  }
  esConfidencialSelecionado(event: any, temaForm: any) {
    const controlCategorizacion = temaForm?.get("categorizacion");
    const id_categorizacion = temaForm?.get("id_categorizacion");
    const corporativo = this.catCategorizacion.find(
      (cat) => cat.descripcion === "C"
    );

    if (!event.checked && corporativo && corporativo.descripcion === "C") {
      controlCategorizacion?.setValue(corporativo.id);
      id_categorizacion?.setValue(corporativo.id);
    } else if (!event.checked && !corporativo) {
      controlCategorizacion.setValue("");
      controlCategorizacion?.setErrors({ required: true });
      controlCategorizacion.markAsTouched();

      id_categorizacion.setValue("");
      id_categorizacion?.setErrors({ required: true });
      id_categorizacion.markAsTouched();
    }

    console.log("esConfidencialSelecionado", event.checked);
    console.log("catCategorizacion", this.catCategorizacion);

    if (event.checked) {
      controlCategorizacion.setValue("");
      controlCategorizacion.markAsTouched();
      id_categorizacion.setValue("");
      id_categorizacion.markAsTouched();
    }

    this.controlRespTouched(temaForm, "respSupervisor");
    this.controlRespTouched(temaForm, "respAnalista");

    // console.log("his.catCategorizacion,", this.catCategorizacion);
    this.esConfidencial(event.checked, temaForm);
  }

  esConfidencial(confidencial: boolean, temaForm: any) {
    //debugger;
    if (!confidencial) {
      temaForm.get("respAnalista")?.setValidators([Validators.required]);
      temaForm.get("respSupervisor")?.setValidators([Validators.required]);
    } else {
      temaForm.get("respAnalista")?.clearValidators();
      temaForm.get("respAnalista")?.setErrors(null);
      temaForm.get("respSupervisor")?.clearValidators();
      temaForm.get("respSupervisor")?.setErrors(null);
    }

    temaForm.get("respAnalista")?.updateValueAndValidity();
    temaForm.get("respSupervisor")?.updateValueAndValidity();
  }

  toggleExpand(temaActual: any) {
    console.log("form", temaActual.value);

    const expanded = temaActual.get("expanded").value;
    const currentId = temaActual.get("editorInstanceId")?.value;

    this.temasAcuerdoArray.controls.forEach((control) => {
      const formControl = control as FormGroup;

      if (formControl.get("editorInstanceId")?.value === currentId) {
        // const esConfidencial = temaActual?.get("esConfidencial").value ?? false;
        // const evento = { checked: esConfidencial };
        // this.esConfidencialSelecionado(
        //   evento,
        //   temaActual?.get('categorizacion')
        // );

        formControl.get("expanded")?.setValue(!expanded);
        // Verificamos si ya existe una instancia del editor; si no, la creamos
        if (!this.editorInstances[currentId]) {
          this.editorInstances[currentId] = new Editor();
        }
      } else {
        formControl.get("expanded")?.setValue(false);

        // Al final de la función, limpiamos editorInstances
        for (const id in this.editorInstances) {
          if (id !== currentId.toString()) {
            this.editorInstances[id].destroy();
            delete this.editorInstances[id];
          }
        }
      }
    });

    console.log("this.editorInstances", this.editorInstances);
  }

  getNombreResponsable($event: any, temaForm: any, nombreResponsable: string) {
    const usuario = this.catUsuarios.find((usuario) => usuario.id === $event);
    temaForm.get(nombreResponsable)?.setValue(usuario ? usuario.nombre : "");
  }

  controlTouched(temaForm: any, form?: any) {
    if (!temaForm?.value) {
      temaForm?.setErrors({ required: true });
    }
    temaForm?.markAsTouched();

    const categorizacion = temaForm.value;

    if (form) {
      const id_categorizacion = form?.get("id_categorizacion");
      id_categorizacion.setValue(categorizacion);
      console.log("id_categorizacion", id_categorizacion);
    }

    console.log("categorizacion", categorizacion);
  }

  controlRespTouched(temaForm: any, controlName: string) {
    const esConfidencial = temaForm?.get("esConfidencial").value;
    const resp = temaForm?.get(controlName).value;

    if (!esConfidencial || esConfidencial == 0) {
      if (!resp) {
        temaForm?.get(controlName)?.setErrors({ required: true });
      }
    } else {
      temaForm?.get(controlName)?.setErrors(null);
    }
    temaForm?.get(controlName)?.markAsTouched();
  }

  get temasAcuerdoArray(): FormArray {
    return this.temasAcuerdo.get("temas") as FormArray;
  }

  dragDropTema(event: CdkDragDrop<AbstractControl[]>, control: any) {
    console.log("temasFormArray", this.temasAcuerdoArray.getRawValue());

    console.log("temascontrolFormArray", control);

    const nuevosTemas = [...this.temasAcuerdoArray.getRawValue()]; // Clonar el array de valores
    const previousIndex = event.previousIndex;
    const currentIndex = event.currentIndex;
    console.log("currentIndex", currentIndex);
    console.log("previousIndex", previousIndex);

    // Mover el ítem dentro del array
    moveItemInArray(nuevosTemas, previousIndex, currentIndex);

    // Buscar el tema que estaba expandido antes del drag
    const temaExpandidoId = nuevosTemas.find((tema: any) => tema.expanded)?.id;

    this.editorInstances = {};
    // Reasignar el índice de cada tema
    const orderedTemas = nuevosTemas.map((tema: any, index: number) => {
      let isExpanded = false;
      const newInstance = "editorInstanceId-" + index;
      // Si el tema tiene id y es el que estaba expandido, mantenerlo expandido
      if (tema.id && tema.id === temaExpandidoId) {
        isExpanded = true;

        this.editorInstances[newInstance] = new Editor();
      }

      // Si el tema es nuevo y estaba expandido, mantenerlo expandido
      if (!tema.id && tema.expanded) {
        isExpanded = true;
        this.editorInstances[newInstance] = new Editor();
      }

      return {
        ...tema,
        editorInstanceId: "editorInstanceId-" + tema.indiceTema,
        expanded: isExpanded,
        indiceTema: index,
      };
    });

    // Crear nuevos FormGroups a partir de los temas ordenados
    const nuevosForm = this.acuerdoUtils.createFormGroupTemas(
      orderedTemas,
      this.catCategorizacion,
      this.catTipoTema
    );

    this.temasAcuerdo.setControl("temas", this.fb.array(nuevosForm)); // Actualizar el FormArray con nuevos controles

    console.log("Formulario actualizado:", this.temasAcuerdo.value);
    console.log("editorInstances final", this.editorInstances);
  }

  dropEntrada(
    event: CdkDragDrop<string[]>,
    entradas: any,
    idTema: string,
    form: any
  ) {
    const nuevasEntradas = [...entradas];
    moveItemInArray(nuevasEntradas, event.previousIndex, event.currentIndex);
    console.log("nuevasEntradas", nuevasEntradas);

    const orderedEntradas = nuevasEntradas.map((ent, index) => ({
      ...ent,
      indiceEntrada: index,
    }));

    form.setValue(orderedEntradas);
  }
  dropEntregables(
    event: CdkDragDrop<string[]>,
    entregables: any,
    idTema: string,
    idEntrada: string,
    form: any
  ) {
    const entradaForm = form.value;
    const nuevosEntregables = [...entregables];
    moveItemInArray(nuevosEntregables, event.previousIndex, event.currentIndex);

    const orderedEntregables = nuevosEntregables.map((ent, index) => ({
      ...ent,
      indice: index,
    }));

    const updatedEntradas = entradaForm.map((entrada: any) => {
      if (entrada.idEntrada === idEntrada) {
        return { ...entrada, entregables: orderedEntregables };
      } else {
        return entrada;
      }
    });

    form.setValue(updatedEntradas);
  }

  dropFiles(
    event: CdkDragDrop<string[]>,
    archivos: any,
    idTema: string,
    idEntrada: string,
    form: any
  ) {
    const entradaForm = form.value;
    const nuevosArchivos = [...archivos];
    moveItemInArray(nuevosArchivos, event.previousIndex, event.currentIndex);
    const orderedFiles = nuevosArchivos.map((ent, index) => ({
      ...ent,
      indiceEnTema: index,
    }));
    const updatedEntradas = entradaForm.map((entrada: any) => {
      if (entrada.idEntrada === idEntrada) {
        return { ...entrada, archivos: orderedFiles };
      } else {
        return entrada;
      }
    });
    form.setValue(updatedEntradas);
  }

  async eliminarEntrda(entrada: INuevaEntrada, form: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "¿Está seguro de eliminar la entrada del tema?",
        message: "Esta acción no se podrá deshacer.",
        showButtons: {
          accept: true,
          cancel: true,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "BORRAR" },
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(() => {
      //this.store.dispatch(eliminarEntrada({ entrada }));

      this.entradasService
        .elimminarEntrada(entrada.idEntrada)
        .subscribe((data) => {
          const formcontrol = form as FormControl;
          const entradasControl = formcontrol.get("entradas");
          const nuevasEntradas = entradasControl?.value.filter((ent: any) => {
            console.log("ent", ent);
            return entrada.idEntrada !== ent.idEntrada;
          });
          entradasControl?.setValue(nuevasEntradas);
          this.store.dispatch(cargarEntradas());
        });
    });

    dialogRef.componentInstance.cancelAction.subscribe(() => {
      console.log("Acción cancelada");
    });

    //se commenta esta linea por que actualmente afecta los datos duplicado en la base
    // this.store.dispatch(eliminarEntrada({ entrada }));
  }
  verArchivo(archivo: any) {
    this.storageService
      .obtenerArchivoUrl(archivo.id_entrada, archivo.nombre_archivo)
      .subscribe((data) => {
        console.log("data", data);
        if (!data.error) {
          window.open(data.url, "_blank");
        }
      });
  }

  eliminarArchivo(_archivo: any, temaForm: any, idEntrada: string) {
    const entradasForms = temaForm.get("entradas");
    console.log("_archivo", _archivo);
    console.log("entradasForms", entradasForms);
    console.log("id_entrada", idEntrada);

    this.loadingService.show();
    this.storageService
      .obtenerArchivoUrl(_archivo.id_entrada, _archivo.nombre_archivo)
      .subscribe((data) => {
        console.log("data", data);
        const archivo: IArchivoAdjunto = {
          id_entrada: _archivo.id_entrada,
          indice: _archivo.indice,
          nombre_archivo: _archivo.nombre_archivo,
          metadata: _archivo.metadata,
          banEsActivo: _archivo.banEsActivo,
          ts_alta_audit: _archivo.ts_alta_audit,
          ts_actualiza_audit: _archivo.ts_actualiza_audit,
          usuario_audit: _archivo.usuario_audit,
          indiceEnTema: _archivo.indiceEnTema,
          url: data.url,
        };

        const updateFiles = entradasForms.value.map((entrada: any) => {
          if (entrada.idEntrada === idEntrada) {
            // Log the current state of archivos
            console.log("Original Archivos:", entrada.archivos);

            const new_archivos = entrada.archivos.filter((archivo: any) => {
              // Log each archivo being checked
              console.log("Checking archivo:", archivo.nombre_archivo);
              console.log("Checking archivo:", archivo.nombre_archivo);
              return archivo.nombre_archivo !== _archivo.nombre_archivo;
            });

            // Log the updated state of archivos
            console.log("New Archivos:", new_archivos);

            return { ...entrada, archivos: new_archivos };
          }
          return entrada;
        });

        this.storageService
          .eliminarArchivoAdjunto(_archivo)
          .subscribe((data) => {
            console.log("data", data);
            if (!data.error) {
              console.log("Updated Entries:", updateFiles);
              entradasForms.setValue(updateFiles);
              this.loadingService.hide();
            }
            if (!data.error) {
              this.loadingService.hide();
            }
          });
      });
  }
  descargarEntregable(entrada: any, entregable: any) {
    this.loadingService.show();
    const id_entrada = entrada.idEntrada ?? entrada.id_entrada;
    const id_entregable = entregable.idEntregable ?? entregable.id_entregable;

    this.entregablesService
      .descargarEntregable({
        entrada: entregable.id_entrada ?? id_entrada,
        entregable: id_entregable,
      })
      .subscribe((result) => {
        console.log("file", result);

        if (result.error || result.data.error) {
          this.loadingService.hide();
          this.showDialog("Alerta", result.data.message.mensaje, true, false);
        } else {
          const ifrm = document.createElement("iframe");
          ifrm.setAttribute("src", result.data[0]);
          ifrm.style.width = "0px";
          ifrm.style.height = "0px";
          ifrm.style.border = "0";
          document.body.appendChild(ifrm);
          setTimeout(() => {
            this.loadingService.hide();
            document.body.removeChild(ifrm);
          }, 1000);
        }
      });
  }

  guardarIndicacion(control: any, temaForm: any) {
    console.log("temaForm guardarIndicacion", temaForm);
    console.log(" control", control);

    const formData = temaForm.value;
    const indicacionValue = control?.value;
    let indicacion: IIndicacionAB = {
      indicacion: "",
      idTema: formData.idTema,
      usuario: this.user.nombre,
      fechaIndicacion: this.formatDate(new Date()),
    };
    if (
      !this.editandoIndicacion &&
      this.hasEmptyFields(this.indicacionActual)
    ) {
      indicacion.indicacion = indicacionValue;
    }
    if (
      this.editandoIndicacion &&
      !this.hasEmptyFields(this.indicacionActual)
    ) {
      indicacion.usuario = this.indicacionActual.usuario;
      indicacion.idTema = this.indicacionActual.idTema;
      indicacion.indicacion = indicacionValue;
      indicacion.idIndicacion = this.indicacionActual.idIndicacion;
    }

    this.indicacionesService.guardarIndicacion(indicacion).subscribe((data) => {
      if (!data.error) {
        indicacion.idIndicacion = data.idIndicacion;
        //this.store.dispatch(nuevoActualizarIndicacion({ indicacion }));
        const indicacionesAB = temaForm.get("indicacionesAB").value;
        console.log("indicacionesAB", indicacionesAB);

        const actualizado = indicacionesAB.find(
          (ind: IIndicacionAB) => ind.idIndicacion == data.idIndicacion
        );

        let all: IIndicacionAB[] = [...indicacionesAB];

        if (!actualizado) {
          all.push({ ...indicacion, idIndicacion: data.idIndicacion });
        } else {
          all = all.map((ind: IIndicacionAB) => {
            if (ind.idIndicacion === data.idIndicacion) {
              return { ...indicacion, idIndicacion: data.idIndicacion };
            }
            return ind;
          });
        }

        temaForm.get("indicacionesAB").setValue(all);
        this.editandoIndicacion = false;
        this.indicacionActual = StateIndicacionAB;
        const controlIndicacion = temaForm.get("indicacion");
        this.cancelarInciacion(controlIndicacion);
      }
      if (data.error) {
        alert("error");
      }
    });
  }

  editIndicacion(indicacionAB: IIndicacionAB, indicacionControl: any) {
    this.indicacionActual = indicacionAB;
    this.editandoIndicacion = true;
    indicacionControl?.setValue(indicacionAB.indicacion);
  }
  cancelarInciacion(controlndicacion: any) {
    controlndicacion.reset();
    controlndicacion?.setValue("");
    this.indicacionActual = StateIndicacionAB;
    this.editandoIndicacion = false;
  }

  hasEmptyFields(obj: IIndicacionAB): boolean {
    for (const key in obj) {
      if (obj[key as keyof IIndicacionAB] === "") {
        return true;
      }
    }
    return false;
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  onFocus(temaForm: any) {
    this.mostrarEntradas = true;
    this.setEntradasOnFocusOnBlur(temaForm);
  }

  onBlur(temaForm: any) {
    setTimeout(() => {
      this.mostrarEntradas = false;
      this.setEntradasOnFocusOnBlur(temaForm);
    }, 200);
  }

  async setEntradasOnFocusOnBlur(temaForm: any) {
    const initialState = await firstValueFrom(
      this.store.select(selectEntradas)
    );
    const entradas = this.temasAcuerdoArray.getRawValue();
    const entradasActuales = entradas.flatMap((tema) => tema.entradas);
    const entradasFiltradas: IEntrada[] = this.filtrarEntradasActuales(
      entradasActuales,
      initialState
    );

    this.listaEntradas = entradasFiltradas;
  }
  async onInput(event: any, temaForm: any) {
    const initialState = await firstValueFrom(
      this.store.select(selectEntradas)
    );
    const entradas = this.temasAcuerdoArray.getRawValue();
    const entradasActuales = entradas.flatMap((tema) => tema.entradas);
    const entradasFiltradas: IEntrada[] = this.filtrarEntradasActuales(
      entradasActuales,
      initialState
    );
    const nombreEntrada = [undefined, null, ""].includes(
      event.target.value.trim()
    )
      ? ""
      : event.target.value.trim();

    if (!nombreEntrada) {
      this.listaEntradas = entradasFiltradas;
    }
    if (nombreEntrada) {
      this.listaEntradas = entradasFiltradas.filter((entrada: IEntrada) => {
        return (
          entrada.nombreEntradaCompleto &&
          entrada.nombreEntradaCompleto
            .toLowerCase()
            .includes(nombreEntrada.toLowerCase())
        );
      });
    }
  }
  filtrarEntradasActuales(
    entradaControl: IEntrada[],
    orignalState: IEntrada[]
  ) {
    return orignalState.filter((entrada: IEntrada) => {
      // Filtrar las entradas que no existen en entradaControl por idEntrada
      return !entradaControl.some(
        (controlEntrada: IEntrada) =>
          controlEntrada.id_entrada === entrada.id_entrada ||
          controlEntrada.idEntrada === entrada.idEntrada
      );
    });
  }

  selectEntrada(option: IEntrada, temaForm: any): void {
    console.log("temaForm", temaForm);

    this.loadingService.show();

    this.acuerdoService
      .getEntregableArchivos(option.id_entrada)
      .then((data) => {
        data.subscribe((files) => {
          console.log("second", files);

          this.loadingService.hide();
          const entradaControl = temaForm.get("entradaSelecionada");

          const temaId = temaForm.get("idTema");
          const nuevoEntrada: INuevaEntrada = {
            id_entrada: option.id_entrada,
            idEntrada: option.id_entrada,
            idCategorizacion: option.id_categorizacion,
            idTema: temaId?.value,
            indiceEntrada: entradaControl?.value.length,
            nombreEntrada: option.nombreEntrada,
            tieneSeguimiento: 0,
            esActivo: option.banEsActivo,
            remitente_descripcion: option.remitente_descripcion,
            fecha_inicio: "",
            documentoSoporte: option.documentoSoporte,
            esDocumentoSoporte: false,
            archivos: [],
            nombreEntradaCompleto: option.nombreEntradaCompleto,
            entregables: [],
          };

          const entregables = files.entregables.map((archivo: any) => {
            archivo.edoEntregable = archivo.id_edo_entregable;
            archivo.new = true;
            return archivo;
          });
          const updatedEntrada = {
            ...nuevoEntrada,
            archivos: [...files.archivos],
            entregables: [...entregables],
          };
          const entradasControl = temaForm.get("entradas");
          const nuevasEntradas = [...entradasControl.value, updatedEntrada];
          entradasControl.setValue(nuevasEntradas);
          const entradaSelected = temaForm.get("entradaSelected");
          entradaSelected.setValue("");
        });
      });

    // descomentarr esta linea al eliminar los datos dupliicados de la bbase
    // this.store.dispatch(
    //   agregarNuevaEntradaSuccess({
    //     temaId: temaId?.value,
    //     entrada: nuevoEntrada,
    //   })
    // );
  }

  showDialog(
    title: string,
    message: string,
    accept: boolean,
    cancel: boolean
  ): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "450px",
      data: {
        title,
        message,
        showButtons: {
          accept,
          cancel,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(() => {
      console.log("Acción confirmada");
    });

    dialogRef.componentInstance.cancelAction.subscribe(() => {
      console.log("Acción cancelada");
    });
  }

  getContador(value: any) {
    return value && value.length > 0 ? stripHtml(value).length : 0;
  }

  async actionSelected(
    action: number,
    formAction: any,
    detalleTema: IDetalleTema
  ) {
    console.log("action", action);

    switch (action) {
      case 1:
        this.loadingService.show();
        const res = await firstValueFrom(this.acuerdosService.getAcuerdos());
        if (!res.error) {
          this.dialog.open(AplazarTemaComponent, {
            width: "550px",
            data: {
              ...detalleTema,
              acuerdoActual: this.acuerdoActual.idFE,
              acuerdos: res.acuerdos,
            },
          });
          this.loadingService.hide();
        } else {
          this.loadingService.hide();
        }
        console.log("acuerdos", res);

        break;
      case 2:
        this.router.navigate([`/mover/mrb/${detalleTema.id}`]);
        break;
      case 3:
        this.dialog.open(QuitarTemaAMrbComponent, {
          width: "550px",
          data: { ...detalleTema, acuerdoActual: this.acuerdoActual },
        });
        break;
      case 4:
        this.loadingService.show();
        const justificacion =
          await this.acuerdosService.consultarJustificacionTerminarTema(
            detalleTema.id
          );
        console.log(justificacion);
        this.loadingService.show();
        if (!justificacion.error) {
          this.loadingService.hide();
          this.dialog.open(TerminarTemaAMrbComponent, {
            width: "550px",
            data: {
              ...detalleTema,
              nombreTema: detalleTema.nombreTema,
              descripcionTema: detalleTema.descripcionTema_html,
              acuerdoActual: this.acuerdoActual,
              justificacion: justificacion.resultado,
            },
          });
        }
        this.loadingService.hide();

        break;
      default:
        break;
    }
    formAction?.setValue("");
  }

  //permisos para edicion/lectura/confidencial...
  getPermisoLectura = (categorizacionTema: string): boolean => {
    const user = structuredClone(this.stateUser.state().usuario);
    return user.lectura.includes(categorizacionTema);
  };

  getPermisoEscritura = (categorizacionTema: string): boolean => {
    const user = structuredClone(this.stateUser.state().usuario);
    return user.escritura.includes(categorizacionTema);
  };

  puedeElimarMaterial(entrada: any): boolean {
    const soloLecura = this.getPermisoLectura(entrada.idCategorizacion);
    const soloEscritura = this.getPermisoEscritura(entrada.idCategorizacion);
    return soloEscritura && soloLecura && !this.esHistorico();
  }

  showEntrada = (entrada: any): boolean => {
    const soloLecura = this.getPermisoLectura(entrada.idCategorizacion);
    const soloEscritura = this.getPermisoEscritura(entrada.idCategorizacion);
    return !soloLecura || (!soloLecura && !soloEscritura);
  };

  esHistorico(): boolean {
    const tipoAcuerdo = structuredClone(
      this.stateTipoAcuerdo.state().acuerdosMRB.tipoAcuerdo
    );
    return tipoAcuerdo === 3;
  }

  disabledEntrada(temaForm:any): Observable<boolean> {
    return this.store.select(selectEntradas).pipe(
      first(),
      map((initialState) => {
        const entradas = this.temasAcuerdoArray.getRawValue();
        const entradasActuales = entradas.flatMap((tema) => tema.entradas);
        const entradasFiltradas: IEntrada[] = this.filtrarEntradasActuales(
          entradasActuales,
          initialState
        );
        const control = temaForm.get("entradaSelected");
         const categorizacion = temaForm.get("categorizacion").value;
         if (this.acuerdoUtils.esHistorico()){
            control.disable();
            return entradasFiltradas.length === 0;
         }
           if (
             entradasFiltradas.length === 0 ||
               !this.acuerdoUtils.getPermisoEscritura(categorizacion)) {
             control.disable();
           } else {
             control.enable();
           }
        return entradasFiltradas.length === 0;
      })
    );
  }
}
